/**
 * Liquor bottle sizes. Red's says sizes in ounces ("a 40"), which are the bottle's nominal
 * size: a 1.75 L bottle is "60 oz" even though it holds 61.6 imperial oz. Bottles are stored
 * in mL (for costs) and shown and added in these nominal ounces.
 */
export const BOTTLES: { oz: number; ml: number }[] = [
  { oz: 13, ml: 375 },
  { oz: 26, ml: 750 },
  { oz: 40, ml: 1140 },
  { oz: 60, ml: 1750 },
];

const ML_PER_OZ = 28.4130625;

/** The size staff say for a bottle: 1140 mL → 40 oz. Other sizes round to the nearest oz. */
export function bottleOz(ml: number | null | undefined): number | null {
  if (!ml) return null;
  return BOTTLES.find((b) => b.ml === ml)?.oz ?? Math.round(ml / ML_PER_OZ);
}

/** Red's metal pour spouts weigh 0.70 oz; bottles are weighed with them on. */
export const DEFAULT_SPOUT_OZ = 0.7;

/** A liquor bottle's spout weight: its own, Red's usual spout, or 0 when it has none. */
export function spoutOf(item: { kind: string; spoutOz?: number | null }): number {
  if (item.kind !== 'liquor' || item.spoutOz === null) return 0;
  return item.spoutOz ?? DEFAULT_SPOUT_OZ;
}

/**
 * What an empty bottle weighs as it's weighed at close: the empty bottle (sheet column B)
 * plus its spout. Null when column B isn't a number.
 */
export function emptyWithSpout(item: { kind: string; colB: number | string | null; spoutOz?: number | null }): number | null {
  if (typeof item.colB !== 'number') return null;
  return Math.round((item.colB + spoutOf(item)) * 100) / 100;
}

/** A size typed in ounces, back to mL: 40 → 1140 (the standard bottle), 33 → 938. */
export function bottleMlOf(oz: number): number {
  return BOTTLES.find((b) => b.oz === oz)?.ml ?? Math.round(oz * ML_PER_OZ);
}
